var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "540px" } },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "form-props": { labelPosition: "left" },
          "layout-mode": "dialog",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          immediate: false,
        },
        scopedSlots: _vm._u([
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "bindTime",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm._f("formatTimestamp")(row.created_at)) + " "
                ),
              ]
            },
          },
          {
            key: "rowActions",
            fn: function ({ row }) {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleEdit(row)
                      },
                    },
                  },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "danger-button",
                    attrs: { size: "mini", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleDelete(row.id)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("BankAccountFormDialog", {
        attrs: {
          visible: _vm.formDialogVisible,
          "is-edit": _vm.isEdit,
          "form-data": _vm.formData,
        },
        on: {
          "update:visible": function ($event) {
            _vm.formDialogVisible = $event
          },
          success: _vm.handleFormSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }